import React from 'react';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';
import './RoadmapResponsive.css';
import { FaSeedling, FaRocket, FaProjectDiagram, FaCoins, FaGlobe, FaChartLine, FaUsers, FaGlobeAmericas } from 'react-icons/fa';

const PHASES = [ 
  {
    id: 0,
    title: 'Phase 0: Pre-Launch & Foundational Prep',
    range: 'Pre-Launch',
    icon: <FaChartLine size={24} />,
    color: 'linear-gradient(135deg, #06b6d4, #3b82f6)',
    bgColor: 'rgba(6, 182, 212, 0.04)',
    completed: [0, 1,2],
    steps: [
      'Concept validation and whitepaper drafting',
      'Core team formation and advisor onboarding',
      'Initial tokenomics & economic model design',
      'Community building and early marketing',
      'Security planning and audit scheduling'
    ]
  },
  {
    id: 1,
    title: 'Phase 1: Token Inception & Foundational Launch',
    range: '0 - 2 Years',
    icon: <FaSeedling size={24} />,
    color: 'linear-gradient(135deg, #3b82f6, #06b6d4)',
    bgColor: 'rgba(59, 130, 246, 0.05)',
    completed: [],
    steps: [
      'Token Generation & Initial Minting (6B supply, 7-year team vesting)',
      'Angle Round Presale (25%) - Discounted private sale to strategic partners',
      'Initial Project Launch: The Virtual Real Estate (3yr stake, 20% interest)',
      'Public Sale & Liquidity Establishment',
      'Core Economic Controls: Buy/Sell/Dump Taxes and TX distribution'
    ]
  },
  {
    id: 2,
    title: 'Phase 2: Core Utility, Stabilization & Metaverse',
    range: 'Year 2',
    icon: <FaRocket size={24} />,
    color: 'linear-gradient(135deg, #8b5cf6, #ec4899)',
    bgColor: 'rgba(139, 92, 246, 0.05)',
    completed: [],
    steps: [
      'DEX Launch (proprietary decentralized exchange)',
      'Deflationary Burning Commencement (10% trade fees burned)',
      'LUMINA Token Generation for sellers and participation',
      'Realityverse Points (RVP) Activation (0.5% buy rewards)',
      'Lumeria Metaverse Deployment and P2E games',
      'P2P Market & Trading Incentives (bonus pools, NFT puzzles)',
      'Liquidity Rewards Program'
    ]
  },
  {
    id: 3,
    title: 'Phase 3: Ecosystem Expansion & Feature Rollout',
    range: 'Year 3',
    icon: <FaProjectDiagram size={24} />,
    color: 'linear-gradient(135deg, #f97316, #fb923c)',
    bgColor: 'rgba(249, 115, 22, 0.05)',
    completed: [],
    steps: [
      'LUMINA Burning Mechanism for in-game purchases',
      'Realityverse Marketplace Launch (RVP redemptions)',
      'Project Participation Platform (fixed returns & profit-share)'
    ]
  },
  {
    id: 4,
    title: 'Phase 4: Sovereign Value & Decentralized Governance',
    range: 'Year 4',
    icon: <FaCoins size={24} />,
    color: 'linear-gradient(135deg, #10b981, #34d399)',
    bgColor: 'rgba(16, 185, 129, 0.05)',
    completed: [],
    steps: [
      'FONTANA Supply Cap at 5B; stop burns',
      'Redirect tax pool to Reality Rewards & Giveaways',
      'Cerulean Token Minting & Vault Establishment',
      'Governance Enrollment: HODL locking for voting rights',
      'CERULEAN DAO Transition to decentralized governance'
    ]
  },
  {
    id: 5,
    title: 'Phase 5: Ecosystem Maturity',
    range: 'Year 5+',
    icon: <FaGlobe size={24} />,
    color: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
    bgColor: 'rgba(99, 102, 241, 0.05)',
    completed: [],
    steps: [
      'Cross-chain interoperability bridge',
      'Strategic RVP Partnerships (travel, retail, services)',
      'Lumeria SDK & Developer Program',
      'DAO Community Incubation & Grants',
      'Global Marketing & CEX Listings for mass adoption'
    ]
  }
];

export default function Roadmap() {
  const currentPhaseIndex = PHASES.findIndex(phase => ((phase.completed || []).length < (phase.steps || []).length));

  return (
    <Container fluid className="litepaper-section mt-5" >
      {/* Header */}
      <div className="mt-5 text-center mb-5">
        <h1 className="text-light" style={{ fontSize: '2.5rem', fontWeight: 700, marginBottom: '12px' }}>
          FONTANA Ecosystem Development Roadmap
        </h1>
        <p className="text-light" style={{ fontSize: '1.1rem', opacity: 0.8 }}>
          Last Updated: 26/12/2025 • Version 2.0
        </p>
        <p className="mt-3"><a href="/whitepaper" className="text-primary">Read the Litepaper / Whitepaper here</a></p>
      </div>

        {/* Phases */}
    {/* Timeline Container */}
      <div className="position-relative" style={{ maxWidth: '900px', margin: '0 auto' }}>
        {/* Vertical Timeline Line */}
        <div 
          className="d-none d-md-block position-absolute"
          style={{
            left: '50%',
            top: 0,
            bottom: 0,
            width: '4px',
            background: 'linear-gradient(to bottom, #3b82f6, #8b5cf6, #f97316, #10b981, #6366f1)',
            transform: 'translateX(-50%)',
            zIndex: 0
          }}
        />

        {/* Timeline Steps */}
        <div>
          {PHASES.map((phase, index) => (
            <div key={phase.id} className="position-relative" style={{ marginBottom: '48px' }}>
              {/* Alternating Layout */}
              <Row className="align-items-center">
                {/* Left Side (odd phases) or Empty (even phases) */}
                <Col md={5} className={`${index % 2 === 0 ? 'text-md-end' : ''} d-none d-md-block`}>
                  {index % 2 === 0 && (
                    <div className="phase-card">
                      <Card.Body className="d-flex gap-3 align-items-center align-items-md-start p-4">
                        <div className="phase-icon-wrapper d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
                          <div
                            className="phase-icon"
                            style={{
                              background: phase.color,
                              borderRadius: '14px',
                              width: '80px',
                              height: '80px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0
                            }}
                          >
                            {phase.icon}
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <div className="phase-meta">
                            <div className="phase-title-wrap">
                              <h3 className="phase-title mb-0">{phase.title}</h3>
                            </div>
                            <div className="phase-range-wrap text-center">
                              <Badge
                                className="text-white d-inline-block"
                                style={{
                                  background: phase.color,
                                  padding: '6px 12px',
                                  borderRadius: '999px',
                                  fontSize: '0.9rem',
                                  fontWeight: 600,
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
                                  display: 'inline-block'
                                }}
                              >
                                {phase.range}
                              </Badge>
                            </div>
                          </div>
                          <ul className="phase-steps">
                            {phase.steps.map((step, i) => {
                              const done = (phase.completed || []).includes(i);
                              const isCurrentPhase = index === currentPhaseIndex;
                              const stepColor = done ? '#10b981' : (isCurrentPhase ? '#f59e0b' : '#c8d3e0');
                              return (
                                <li key={i} className="phase-step" style={{ color: stepColor }}>
                                  <span style={{ textDecoration: done ? 'line-through' : 'none' }}>{step}</span>
                                  {done && <span style={{ textDecoration: 'none', color: '#10b981', marginLeft: '8px' }}>✓</span>}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </Card.Body>
                    </div>
                  )}
                </Col>
                <Col md={2} className="d-none d-md-flex align-items-center justify-content-center">
                  <div
                    className="center-node d-flex align-items-center justify-content-center"
                    style={{
                      background: phase.bgColor,
                      border: '4px solid rgba(255,255,255,0.06)',
                      width: '64px',
                      height: '64px',
                      borderRadius: '50%',
                      fontWeight: 700,
                      fontSize: '1.2rem',
                      zIndex: 10,
                      position: 'relative',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                    }}
                  >
                    {phase.id}
                  </div>
                </Col>

                {/* Right Side (even phases) or Empty (odd phases) */}
                <Col md={5} className="d-none d-md-block">
                  {index % 2 === 1 && (
                    <div className="phase-card">
                      <Card.Body className="d-flex gap-3 align-items-center align-items-md-start p-4">
                        <div className="phase-icon-wrapper d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
                          <div
                            className="phase-icon"
                            style={{
                              background: phase.color,
                              borderRadius: '14px',
                              width: '80px',
                              height: '80px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0
                            }}
                          >
                            {phase.icon}
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <div className="phase-meta">
                            <div className="phase-title-wrap">
                              <h3 className="phase-title mb-0">{phase.title}</h3>
                            </div>
                            <div className="phase-range-wrap text-center">
                              <Badge
                                className="text-white d-inline-block"
                                style={{
                                  background: phase.color,
                                  padding: '6px 12px',
                                  borderRadius: '999px',
                                  fontSize: '0.9rem',
                                  fontWeight: 600,
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
                                  display: 'inline-block'
                                }}
                              >
                                {phase.range}
                              </Badge>
                            </div>
                          </div>
                          <ul className="phase-steps">
                            {phase.steps.map((step, i) => {
                              const done = (phase.completed || []).includes(i);
                              const isCurrentPhase = index === currentPhaseIndex;
                              const stepColor = done ? '#10b981' : (isCurrentPhase ? '#f59e0b' : '#c8d3e0');
                              return (
                                <li key={i} className="phase-step" style={{ color: stepColor }}>
                                  <span style={{ textDecoration: done ? 'line-through' : 'none' }}>{step}</span>
                                  {done && <span style={{ textDecoration: 'none', color: '#10b981', marginLeft: '8px' }}>✓</span>}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </Card.Body>
                    </div>
                  )}
                </Col>

                {/* Mobile View - Full Width */}
                <Col xs={12} className="d-md-none">
                  <div className="phase-card">
                    <Card.Body className="d-flex flex-column flex-md-row gap-3 align-items-center align-items-md-start p-4">
                      <div className="phase-icon-wrapper d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
                        <div
                          className="phase-icon"
                          style={{
                            background: phase.color,
                            borderRadius: '14px',
                            width: '80px',
                            height: '80px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0
                          }}
                        >
                          {phase.icon}
                        </div>
                      </div>
                      <div className="flex-grow-1 text-center text-md-start">
                        <div className="phase-meta">
                          <h3 className="phase-title">{phase.title}</h3>
                          <div className="phase-range-wrap text-center mt-1">
                            <Badge
                              className="text-white d-inline-block"
                              style={{
                                background: phase.color,
                                padding: '6px 12px',
                                borderRadius: '999px',
                                fontSize: '0.9rem',
                                fontWeight: 600,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
                                display: 'inline-block'
                              }}
                            >
                              {phase.range}
                            </Badge>
                          </div>
                        </div>
                        <ul className="phase-steps text-center text-md-start">
                          {phase.steps.map((step, i) => {
                            const done = (phase.completed || []).includes(i);
                            const isCurrentPhase = index === currentPhaseIndex;
                            const stepColor = done ? '#10b981' : (isCurrentPhase ? '#f59e0b' : '#c8d3e0');
                            return (
                              <li key={i} className="phase-step" style={{ color: stepColor }}>
                                <span style={{ textDecoration: done ? 'line-through' : 'none' }}>{step}</span>
                                {done && <span style={{ textDecoration: 'none', color: '#10b981', marginLeft: '8px' }}>✓</span>}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </Card.Body>
                  </div>
                </Col>
              </Row>

              {/* Spacing Divider */}
              {index < PHASES.length - 1 && (
                <div className="d-none d-md-block" style={{ 
                  height: '1px', 
                  background: `linear-gradient(to right, transparent, ${phase.color.split(',')[1]?.split(')')[0] || '#06a1bd'}40, transparent)`,
                  margin: '32px auto',
                  maxWidth: '600px'
                }} />
              )}
            </div>
          ))}
        </div>
      </div>
      
     

      {/* Stats Footer */}
      <Row className="g-4 mt-5" style={{ maxWidth: '1200px', margin: '80px auto 0' }}>
        <Col xs={12} md={4}>
          <Card 
            className="text-center shadow-lg border-0 h-100"
            style={{
              background: 'rgba(255,255,255,0.05)',
              borderRadius: '16px',
              border: '2px solid rgba(59,130,246,0.2)',
              transition: 'box-shadow 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 12px 30px rgba(59,130,246,0.3)'}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.2)'}
          >
            <Card.Body style={{ padding: '24px' }}>
              <div 
                className="d-inline-flex align-items-center justify-content-center text-white mb-3"
                style={{
                  width: '56px',
                  height: '56px',
                  background: 'linear-gradient(135deg, #3b82f6, #06b6d4)',
                  borderRadius: '50%',
                  boxShadow: '0 4px 12px rgba(59,130,246,0.4)'
                }}
              >
                <FaChartLine size={28} />
              </div>
              <div className="text-light" style={{ fontSize: '2rem', fontWeight: 700 }}>7+ Years</div>
              <div className="text-light" style={{ fontSize: '0.9rem', marginTop: '8px', opacity: 0.8 }}>
                Total Duration
              </div>
            </Card.Body>
          </Card>
        </Col>
        
        <Col xs={12} md={4}>
          <Card 
            className="text-center shadow-lg border-0 h-100"
            style={{
              background: 'rgba(255,255,255,0.05)',
              borderRadius: '16px',
              border: '2px solid rgba(139,92,246,0.2)',
              transition: 'box-shadow 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 12px 30px rgba(139,92,246,0.3)'}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.2)'}
          >
            <Card.Body style={{ padding: '24px' }}>
              <div 
                className="d-inline-flex align-items-center justify-content-center text-white mb-3"
                style={{
                  width: '56px',
                  height: '56px',
                  background: 'linear-gradient(135deg, #8b5cf6, #ec4899)',
                  borderRadius: '50%',
                  boxShadow: '0 4px 12px rgba(139,92,246,0.4)'
                }}
              >
                <FaUsers size={28} />
              </div>
              <div className="text-light" style={{ fontSize: '2rem', fontWeight: 700 }}>5 Phases</div>
              <div className="text-light" style={{ fontSize: '0.9rem', marginTop: '8px', opacity: 0.8 }}>
                Key Milestones
              </div>
            </Card.Body>
          </Card>
        </Col>
        
        <Col xs={12} md={4}>
          <Card 
            className="text-center shadow-lg border-0 h-100"
            style={{
              background: 'rgba(255,255,255,0.05)',
              borderRadius: '16px',
              border: '2px solid rgba(16,185,129,0.2)',
              transition: 'box-shadow 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 12px 30px rgba(16,185,129,0.3)'}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.2)'}
          >
            <Card.Body style={{ padding: '24px' }}>
              <div 
                className="d-inline-flex align-items-center justify-content-center text-white mb-3"
                style={{
                  width: '56px',
                  height: '56px',
                  background: 'linear-gradient(135deg, #10b981, #34d399)',
                  borderRadius: '50%',
                  boxShadow: '0 4px 12px rgba(16,185,129,0.4)'
                }}
              >
                <FaGlobeAmericas size={28} />
              </div>
              <div className="text-light" style={{ fontSize: '2rem', fontWeight: 700 }}>Global</div>
              <div className="text-light" style={{ fontSize: '0.9rem', marginTop: '8px', opacity: 0.8 }}>
                Ecosystem Reach
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

